// abstract convenience functions
// generally curried, specifying data/collections as last params

// https://stackoverflow.com/a/9538602/174965
const isFn = (fn) => Object.prototype.toString.call(fn) === '[object Function]'

// functators - things that pass functions through, but
// convert non-functions in useful ways.

// iff val is not a fn, replace it with a tautologic fn returning val
// other waise return val unchanged ( as a fn )
const functate = (val) => (isFn(val) ? val : () => val)

// iff key is not a fn, replace it with an arity:1 mapping function
// that retreives a property named by key (a fetcher)
// todo: consider evaluating non-fn property with fetch, for compound keys
const atFunctate = (key) => (isFn(key) ? key : (o) => o[key])

// builds an object by iterating an array, and computing a key
// for each element, as specified by keyFn which is either a mapping
// fn as (val, index, array) => any,
// or simply a string specifiying the property name to fetch
const keyBy = (keyFn) => (arr) =>
  arr.slice().reduce(
    (acc, val, idx, arr) => {
      acc[atFunctate(keyFn)(val, idx, arr)] = val
      return acc
    },
    {} // start with empty object
  )

// TODO: test
const keyValBy = (keyFn) => (valFn) => (arr) =>
  arr.slice().reduce(
    (acc, val, idx, arr) => {
      acc[atFunctate(keyFn)(val, idx, arr)] = atFunctate(valFn)(val, idx, arr)
      return acc
    },
    {} // start with empty object
  )

// TODO: test
// returns all keys in an object, whose values satisify
// the predicate: fn(val, key, obj)
const keysWhich = (pred) => (obj) =>
  Object.entries(obj)
    .filter((el) => pred(el[1], el[0], obj))
    .map((el) => el[0])

const copyKeys = (keys) => (obj) => {
  let copy = {}
  keys.forEach((k) => {
    if (obj.hasOwnProperty(k)) {
      copy[k] = obj[k]
    }
  })
  return copy
}

// TODO: this is actually 'get' in lowdash parlance
const at = (path, fallback = '') => (obj) => {
  // get keys sequence, bail if stuff is broke
  if (
    obj === undefined ||
    obj === null ||
    path === undefined ||
    path === null ||
    !path.toString
  ) {
    return fallback
  }
  let keys = path.toString().split('.')
  if (!keys.length) {
    return fallback
  }

  // fn to recursively traverse obj, storing last keyed prop as cur
  let cur = obj
  let dig = () => {
    let key = keys.shift()
    if (cur[key] !== undefined) {
      cur = cur[key]
      return keys.length ? dig() : cur
    } else {
      return fallback
    }
  }

  // do the thing
  return dig()
}

const stringToPropName = (str) =>
  str
    .split(' ')
    .filter((x) => x !== '')
    .join('_')
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, '')

// safe json serializer from https://github.com/isaacs/json-stringify-safe
const serializer = (replacer, cycleReplacer) => {
  let stack = []
  let keys = []

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) return '[Circular ~]'
      return (
        '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']'
      )
    }
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    } else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}

const stringify = (obj, replacer, spaces, cycleReplacer) =>
  JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)

// angular like constructors apparently
function FnService() {
  return {
    isFn,
    functate,
    atFunctate,
    keyBy,
    keyValBy,
    keysWhich,
    at,
    copyKeys,
    stringToPropName,
    stringify,
  }
}

export default [FnService]
